import { render } from "./Concept_en.vue?vue&type=template&id=030af79c"
import script from "./Concept_en.vue?vue&type=script&lang=js"
export * from "./Concept_en.vue?vue&type=script&lang=js"
script.render = render

export default script